import { render, staticRenderFns } from "./serviceArea.vue?vue&type=template&id=480df9bf&scoped=true&"
import script from "./serviceArea.vue?vue&type=script&lang=js&"
export * from "./serviceArea.vue?vue&type=script&lang=js&"
import style0 from "./serviceArea.vue?vue&type=style&index=0&id=480df9bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480df9bf",
  null
  
)

export default component.exports